<template>
    <div id="app">
        <div class="header">
            <el-date-picker
                    v-model="now_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    style="vertical-align: middle;margin-top: -4px;"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>

            <!-- <input type="text" class="name" style="width: 90px;" v-model="vip_name" placeholder="会员姓名" @keyup.enter="search" />
            <input type="text" class="name" style="width: 90px;" v-model="cabeza_name" placeholder="家长姓名" @keyup.enter="search" />
            <input type="text" class="name" style="width: 140px;" maxlength="11" v-model="cabeza_tel" placeholder="家长电话" @keyup.enter="search" /> -->

            <select name="" class="select1 name" v-model="selectVal"
                    style="width: 90px;height: 38px;padding-left:10px;">
                <option value="">状态</option>
                <option v-for="item in option1" :value="item.name">
                    {{item.name}}
                </option>
            </select>

            <select name="" class="select2 name" v-if="show_zj == 1" v-model="select_Val"
                    style="width: 90px;height: 38px;">
                <!--<select name="" class="select2 name" @change="market_save" v-if="show_zj == 1" v-model="select_Val" style="width: 90px;height: 38px;">-->
                <option value="">采单人</option>
                <option v-for="(item,index) in options" :value="item.user_id">
                    {{ item.username }}
                </option>
            </select>

            <select name="" class="select3 name" v-model="select3Val"
                    style="width: 90px;height: 38px;padding-left:10px;">
                <option value="">来源</option>
                <option v-for="item in option2" :value="item.label">
                    {{item.label}}
                </option>
            </select>

            <el-button type="warning" @click="search" icon="el-icon-search"></el-button>
            <button class="refresh-btn" @click="clear_search">
                <i class="el-icon-refresh"></i>
            </button>

            <!-- <el-button class="delete" v-if="show_zj == 1" :plain="true" @click="del">删除所属顾问</el-button> -->
            <el-dialog
                    title="删除所属顾问"
                    :visible.sync="centerDialogVisible"
                    width="30%"
                    center>
                <span>确认将顾问：{{select_name}}下的所有用户（{{market_num}}人）重新分配？且不可恢复</span>
                <span slot="footer" class="dialog-footer">
			    <el-button @click="centerDialogVisible = false">取 消</el-button>
			    <el-button type="warning" @click="del_market">确 定</el-button>
			  </span>
            </el-dialog>
        </div>

        <el-table
                :data="tableData"
                border
                style="width: 100%"
                >
            <el-table-column
                    prop="gj_type"
                    width="100"
                    label="状态">
            </el-table-column>
            <el-table-column
                    prop="create_time"
                    width="100"
                    label="创建时间">
            </el-table-column>
            <el-table-column
                    width="90"
                    label="会员姓名">
                <template slot-scope="scope">
                    <span style="cursor: pointer;">{{ scope.row.baobao_name ? scope.row.baobao_name : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="90"
                    label="家长姓名">
                <template slot-scope="scope">
                    <span>{{ scope.row.p_name ? scope.row.p_name : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="110"
                    label="电话">
                <template slot-scope="scope">
                    <span>{{ scope.row.p_phone ? scope.row.p_phone : '--' }}</span>
                </template>
            </el-table-column>

            <el-table-column
                    width="100"
                    label="会员生日">
                <template slot-scope="scope">
                    <span>{{ scope.row.baobao_birthday ? scope.row.baobao_birthday : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="100"
                    label="采单人">
                <template slot-scope="scope">
                    <span>{{ scope.row.username ? scope.row.username : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="100"
                    label="来源">
                <template slot-scope="scope">
                    <span>{{ scope.row.laiyuan ? scope.row.laiyuan : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="100"
                    label="上次跟进">
                <template slot-scope="scope">
                    <span>{{ scope.row.last ? scope.row.last : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="跟进记录">
                <template slot-scope="scope">
                    <span style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{ scope.row.neirong ? scope.row.neirong : '--' }}</span>
                </template>
            </el-table-column>
        </el-table>

        <!--修改弹出框-->
        <form id="forms" action="" method="post">
            <el-dialog
                    title="修改潜客信息"
                    :visible.sync="dialogVisible"
                    width="600px">
                <label style="margin: 0 5px 0 20px;">姓名</label>
                <input type="text" class="save-input" style="margin-right: 90px;" v-model="save_list2.baobao_name"
                       placeholder="请输入会员姓名" name="baobao_name" id="" value=""/>
                <label>别名</label>
                <input type="text" class="save-input" placeholder="请输入会员别名" v-model="save_list2.baobao_name2"
                       name="baobao_name2" id="" value=""/><br/>

                <label style="margin: 0 5px 0 20px;">生日</label>
                <el-date-picker
                        v-model="save_list2.baobao_birthday"
                        type="date"
                        name="baobao_birthday"
                        size="mini"
                        placeholder="选择日期">
                </el-date-picker>

                <label style="margin-left: 90px;">性别</label>
                <el-radio name="baobao_sex" v-model="save_list2.baobao_sex" label="男">男</el-radio>
                <el-radio name="baobao_sex" v-model="save_list2.baobao_sex" label="女">女</el-radio>
                <br/>

                <label style="margin: 0 5px 0 20px;">来源</label>
                <select name="laiyuan" v-model="save_list2.laiyuan" style="width: 159px;height:28px;margin-top: 10px;"
                        class="save-input">
                    <option v-for="item in option2" :value="item.label">
                        {{item.label}}
                    </option>
                </select>

                <div style="margin: 14px 5px 0 20px;">家长联系方式</div>
                <input type="hidden" name="user_id" id="" value="" v-model="save_list2.user_id"/>
                <input type="hidden" name="token" id="" value="" v-model="token"/>

                <div class="line" style="margin-top: 6px;" v-for="(item,index) in save_list">
                    <span>关系</span>
                    <select name="guanxi[]" v-model="item.g_value" style="width: 100px;height: 28px;margin-right: 10px;"
                            class="save-input">
                        <option v-for="item in relation" :value="item.value">
                            {{item.name}}
                        </option>
                    </select>

                    <span>姓名</span>
                    <input type="text" placeholder="请输入家长姓名" style="width: 105px;margin-right: 10px;"
                           v-model="item.p_name" class="save-input" name="name[]" id="" value=""/>

                    <span>联系电话</span>
                    <input type="tel" placeholder="请输入家长电话" maxlength="11" style="width: 105px;" v-model="item.p_phone"
                           class="save-input" name="phone[]" id="" value=""/>
                </div>

                <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="warning" @click="confirm_save">确 定</el-button>
		  </span>
            </el-dialog>
        </form>

        <!--分页-->
        <div class="block" style="margin-top: 15px;">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    prev-text="上一页"
                    next-text="下一页"
                    :current-page="currentPage"
                    :page-size="10"
                    :total="totalNum">
            </el-pagination>
        </div>

        <!--转给他人-->
        <el-dialog
                title="提示"
                :visible.sync="DialogVisible"
                width="30%">
            <span style="color: red;vertical-align: middle;">*</span>
            <label>选择销售：</label>
            <select name="" v-model="sell_name" style="width: 250px;height: 30px;">
                <option value="">请选择销售</option>
                <option v-for="(item,index) in sellData" :value="item.user_id">
                    {{ item.username }}
                </option>
            </select>
            <span slot="footer" class="dialog-footer">
		    <el-button @click="DialogVisible = false">取 消</el-button>
		    <el-button type="warning" @click="confirm_move">确 定</el-button>
		  </span>
        </el-dialog>

        <!--退回公海-->
        <el-dialog
                title="提示"
                :visible.sync="send_state"
                width="30%">
            <span>确定删除此学员？</span>
            <span slot="footer" class="dialog-footer">
		    <el-button @click="send_state = false">取 消</el-button>
		    <el-button type="warning" @click="confirm_back">确 定</el-button>
		  </span>
        </el-dialog>

        <!--潜客详细信息-->
        <transition name="fade">
            <div class="right-pop" v-show="popShow">
                <div></div>
                <div class="head">
                    <img src="/static/qmsj/img/genjin/boshi.png" class="head-img"/>
                    <span class="name">{{popData.baobao_name ? popData.baobao_name : '--'}}</span>
                    <div class="right">
                        <span class="move" @click="move">转给他人</span>
                        <span class="move" @click="send_back">删除</span>
                        <img src="/static/qmsj/img/genjin/Close.png" @click="close" class="close"/>
                    </div>

                    <div class="head_content">
                        <span>最后跟进时间：{{popData.lasttime ? popData.lasttime : '--'}}</span>
                        <span>下次跟进时间：{{popData.lastgjtime ? popData.lastgjtime : '--'}}</span>
                        <span>负责销售：{{popData.gwname ? popData.gwname : '--'}}</span>
                        <span>跟进状态：{{popData.gj_type ? popData.gj_type : '--'}}</span>
                    </div>
                </div>

                <!--tab切换-->
                <el-tabs type="border-card">
                    <el-tab-pane label="详细信息">
                        <!-- 展示信息的组件 -->
                        <genjinInfoBox :popData="popData"></genjinInfoBox>
                    </el-tab-pane>

                    <el-tab-pane label="跟进记录">
                        <textarea v-model="text_val" placeholder="新建跟进记录...(必填，限200字)" name="" rows=""
                                  cols=""></textarea>
                        <form class="down_form">
                            <select name="" v-model="way_val" style="width: 12%;height: 27px;float: left;">
                                <option value="">跟进方式</option>
                                <option v-for="item in way" :value="item.name">
                                    {{item.name}}
                                </option>
                            </select>

                            <el-date-picker
                                    value-format="yyyy-MM-dd"
                                    v-model="make_time"
                                    size="mini"
                                    type="date"
                                    placeholder="预约到访时间">
                            </el-date-picker>

                            <el-date-picker
                                    value-format="yyyy-MM-dd"
                                    v-model="last_time"
                                    size="mini"
                                    type="date"
                                    placeholder="下次跟进时间">
                            </el-date-picker>

                            <select name="" v-model="follow_val" style="height: 27px;margin-left: 5px;">
                                <option value="">跟进状态</option>
                                <option v-for="item in follow_type" value="item.name">
                                    {{item.name}}
                                </option>
                            </select>
                            <input type="button" class="issue" name="" id="" @click="issue" value="发布"/>

                            <!--跟进记录-->
                            <div class="record-content" v-for="(item,index) in recordData" v-show="recordShow">
                                <div class="record">
                                    <span>跟进时间: {{item.create_time ? item.create_time : '--'}}</span>
                                    <span>预约时间: {{item.st_time ? item.st_time : '--'}}</span>
                                    <span>
					  	 		跟进方式: {{item.fangshi ? item.fangshi : '--'}}
					  	 		<button :class="item.visittype=='已到访' ? 'yet' : 'not'" @click="visit(item.gj_id)"
                                        v-show="item.st_time">{{item.visittype}}</button>
					  	 	</span>
                                </div>
                                <img src="/static/qmsj/img/genjin/header.png" class="header-img"/>
                                <span class="img-txt">{{item.username ? item.username : '--'}}</span>
                                <span class="right-txt" @click="del_record(item.gj_id)">删除</span>
                                <div class="content">{{item.neirong ? item.neirong : '--'}}</div>
                            </div>
                        </form>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </transition>

        <!--删除跟进记录-->
        <el-dialog
                title="删除"
                :visible.sync="del_dialogVisible"
                width="30%"
                :before-close="handleClose">
            <span>是否删除此条记录？</span>
            <span slot="footer" class="dialog-footer">
		    <el-button @click="del_dialogVisible = false">取 消</el-button>
		    <el-button type="warning" @click="confirm_del">确 定</el-button>
		  </span>
        </el-dialog>


    </div>
</template>

<script>
    import genjinInfoBox from "../../components/genjinInfoBox";

    export default {
        components: {genjinInfoBox},
        data() {
            return {
                dialog_qiandao: true,
                now_time: '',
                value2: '',
                //分页
                totalNum: 0,
                now_page: 1,
                currentPage: 1,
                isShow: false,
                show_zj: 2,
                //表格
                vip_name: '',
                cabeza_name: '',
                cabeza_tel: '',
                selectVal: '',
                select_Val: '',
                select3Val: '',
                select_name: '',
                token: '',
                userid: '',
                popData: [],
                recordData: [],//跟进记录
                name_id: '',//会员姓名ID
                record_id: '',
                recordShow: false,
                sell_name: '',
                sellData: [],
                popShow: false,
                dialogVisible: false,
                DialogVisible: false,
                centerDialogVisible: false,
                market_num: 0, //顾问数量
                time_s: '',
                time_e: '',
                //到访按钮
                visit_txt: '未到访',
                option1: [
                    {name: '新客户'},
                    {name: '重点关注'},
                    {name: '新分配'},
                    {name: '已跟进'},
                    {name: '持续跟进'},
                    {name: '预约未到访'},
                    {name: '已到访'},
                    {name: '放弃'}
                ],
                relation: [
                    {name: '爸爸', value: 1},
                    {name: '妈妈', value: 2},
                    {name: '爷爷', value: 3},
                    {name: '奶奶', value: 4},
                    {name:'姥爷',value:5},
                    {name:'姥姥',value:6},
                ],
                option2: "",
                way: [
                    {name: '电话'},
                    {name: '短信'},
                    {name: '到店'}
                ],
                week: [
                    {name: '星期一', value: 1},
                    {name: '星期二', value: 2},
                    {name: '星期三', value: 3},
                    {name: '星期四', value: 4},
                    {name: '星期五', value: 5},
                    {name: '星期六', value: 6},
                    {name: '星期日', value: 7}
                ],
                follow_type: [
                    {name: '重点关注'},
                    {name: '已跟进'},
                    {name: '持续跟进'},
                    {name: '预约未到访'},
                    {name: '已到访'},
                    {name: '放弃'}
                ],
                courseData: [], //班级名称数据
                text_val: '', //跟进内容
                way_val: '',//跟进方式
                week_val: '',//跟进日期
                make_time: '',//预约时间
                last_time: '', //下次跟进时间
                follow_val: '',//跟进状态
                course_val: '', //选择班级名称
                ids: '', //记录id
                options: [],
                tableData: [],
                tables: [],
                //修改弹出框
                radio: '男',
                save_list: [],
                save_list2: [],
                del_dialogVisible: false, //删除记录
                del_id: '',//删除记录ID
                send_state: false, //退回公海
                isSubmit: false
            }
        },
        created() {
            //下拉框数据
            let that = this
            that.token = that.$cookies.get('token');
            $.ajax({
                url: process.env.apiUrl +'saas/qks/procurement',
                type: 'post',
                data: {
                    token: that.token
                },
                success: function (data, status) {
                    that.options = data.data
                },
                fail: function (err, status) {
                    console.log(err)
                }
            })
            //请求表格数据
            that.getData();
            // 来源下拉
            $.ajax({
                url: process.env.apiUrl +'saas/index/get_source',
                type: 'post',
                data: {
                    token: that.token
                },
                success: function (e) {
                    console.log(e)
                    that.option2 = e.data
                },
            })
        },
        methods: {
            //表格数据
            getData() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qks/index',
                    type: 'post',
                    data: {
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.tableData = data.data
                            that.totalNum = Number(data.map.count)
                            that.show_zj = data.show_zj;
                        } else {
                            that.tableData = [];
                            that.totalNum = Number(0)
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //搜索
            search() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qks/index',
                    type: 'post',
                    data: {
                        time_s: that.time_s,
                        time_e: that.time_e,
                        type: that.selectVal,
                        salesperson: that.select_Val,
                        laiy: that.select3Val,
                        page: 1,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.tableData = data.data
                            that.totalNum = Number(data.map.count)
                        } else {
                            that.tableData = [];
                            that.totalNum = Number(0)
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //修改信息
            update(id) {
                let that = this
                that.dialogVisible = true
                $.ajax({
                    url: process.env.apiUrl +'saas/Qk/edit_qk_info',
                    type: 'post',
                    data: {
                        user_id: id,
                        token: that.token
                    },
                    success: function (data, status) {
                        that.save_list = data.guanxi
                        that.save_list2 = data.userinfo
                        console.log(that.save_list)
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //确认修改
            confirm_save() {
                this.dialogVisible = false
                //提交修改表单
                var formData = new FormData($('#forms')[0]);
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/Qk/update_qk_info',
                    type: "post",
                    async: false,
                    processData: false, // 不处理发送的数据，因为data值是Formdata对象，不需要对数据做处理
                    contentType: false, // 不设置Content-type请求头
                    data: formData,
                    success: function (data) {
                        if (data.status == 1) {
                            that.getData();
                            that.save_success();
                        }
                    },
                    fail: function (err) {
                        console.log(err)
                    }
                })
            },
            //修改成功
            save_success() {
                this.$message({
                    message: '修改成功',
                    type: 'success'
                });
            },
//			右侧弹出框
            pop(id) {
                document.documentElement.scrollTop = document.body.scrollTop = 0;
                this.popShow = true
                this.record_id = id

                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/nn/details',
                    type: 'post',
                    data: {
                        userid: id,
                        token: that.token
                    },
                    success: function (data, status) {
                        that.popData = data.data
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
                //跟进记录数据
                that.get_record();
            },
            //跟进记录
            get_record() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/nn/follow',
                    type: 'post',
                    data: {
                        user_id: that.record_id,
                        token: that.token
                    },
                    success: function (data, status) {
                        that.recordData = data.data
                        if (data.status == 1) {
                            that.recordShow = true
                            that.recordLength = data.data.length
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
//			删除跟进记录
            del_record(id) {
                let that = this
                that.del_dialogVisible = true
                $.ajax({
                    url: process.env.apiUrl +'saas/nn/del',
                    type: 'post',
                    data: {
                        gj_id: id,
                        token: that.token
                    },
                    success: function (data, status) {
                        console.log(data)
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //确认删除记录
            confirm_del() {
                this.del_dialogVisible = false

                let that = this
                that.get_record();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {
                    });
            },
//			转给他人
            move() {
                this.DialogVisible = true
                let self = this
                //销售人员列表
                $.ajax({
                    url: process.env.apiUrl +'saas/qk/yxlb',
                    type: 'post',
                    data: {
                        token: self.token
                    },
                    success: function (data, status) {
                        self.sellData = data.data
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
//          确认
            confirm_move() {
                this.DialogVisible = false

                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qk/zgtr',
                    type: 'post',
                    data: {
                        user_id: that.record_id,
                        uid: that.sell_name,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.move_success();
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            move_success() {
                this.$message({
                    message: '分配成功',
                    type: 'success'
                });
            },
            //根据日期选择班级名称
            week_save() {
                let self = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qk/xzkc',
                    type: 'post',
                    data: {
                        week: self.week_val,
                        token: self.token
                    },
                    success: function (data, status) {
                        self.courseData = data.data
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //发布
            issue() {
                if (this.isSubmit) {
					return
				}
				this.isSubmit = true
                let self = this
                $.ajax({
                    url: process.env.apiUrl +'saas/nn/addfollow',
                    type: 'post',
                    data: {
                        bao_id: self.record_id,
                        neirong: self.text_val,
                        fangshi: self.way_val,
                        st_time: self.make_time,
                        lasttime: self.last_time,
                        zhuangtai: self.follow_val,
                        token: self.token
                    },
                    success: function (data, status) {
                        if (self.text_val == '') {
                            alert('请输入跟进内容')
                            return false;
                        }
                        if (data.status == 1) {
                            self.getData()
                            self.$message.success('添加成功');
                            //添加跟进记录
                            self.get_record();
                            //清空已添加的跟进内容
                            self.text_val = ''; //文本域
                            self.way_val = '';//跟进方式
                            self.week_val = '';//跟进日期
                            self.make_time = '';//预约时间
                            self.last_time = ''; //下次跟进时间
                            self.follow_val = '';//跟进状态
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    },
					complete: function() {
						self.isSubmit = false
					}
                })
            },
            //到访按钮
            visit(id1, key) {
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qk/dfqh',
                    type: 'post',
                    data: {
                        id: id1,
                        token: this.token
                    },
                    success: function (data, status) {
                        console.log(data)
                        that.get_record();
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
//          关闭右侧弹出框
            close() {
                this.popShow = false
            },
            //退回公海
            send_back() {
                this.send_state = true
            },
            confirm_back() {
                this.send_state = false

                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qk/tuihui',
                    type: 'post',
                    data: {
                        user_id: that.record_id,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            //刷新视图
                            that.getData();
                            that.send_success();
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            send_success() {
                this.$message({
                    message: '已退回公海',
                    type: 'success'
                });
            },
            //删除所属顾问
            del() {
                this.select_name = $(".select2").find("option:selected").text();
                if (this.select_Val == '') {
                    this.$message({
                        duration: 2000,
                        showClose: true,
                        message: '请先选择顾问',
                        type: 'error'
                    });
                } else {
                    this.centerDialogVisible = true
                }
            },
            del_market() {
                this.centerDialogVisible = false

                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qk/hg',
                    type: 'post',
                    data: {
                        userid: that.select_Val,
                        token: that.token
                    },
                    success: function (data, status) {
                        //请求表格数据
                        that.clear_search();
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.now_page = val
                console.log(`当前页: ${val}`);
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qks/index',
                    type: 'post',
                    data: {
                        time_s: that.time_s,
                        time_e: that.time_e,
                        type: that.selectVal,
                        salesperson: that.select_Val,
                        laiy: that.select3val,
                        page: that.now_page,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.tableData = data.data
                            that.totalNum = Number(data.map.count)
                        } else {
                            return false
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //清空搜索条件
            clear_search() {
                this.vip_name = '';
                this.cabeza_name = '';
                this.cabeza_tel = '';
                this.selectVal = '';
                this.select_Val = '';
                this.select3Val = '';

                let that = this
                that.getData();
            }
        },
        watch: {
            now_time() {
                if (this.now_time) {
                    this.time_s = this.now_time[0]
                    this.time_e = this.now_time[1]
                } else {
                    this.time_s = ''
                    this.time_e = ''
                }
            }
        }
    };
</script>
<style>
    .el-date-editor .el-range-separator {
        width: auto;
    }

    .el-dialog__header {
        padding: 10px 20px 10px;
        color: #FFFFFF;
        background: #E6BE8A;
        text-align: center;
    }

    .el-dialog__title {
        color: #FFFFFF;
    }
</style>
<style lang="less" scoped="scoped">
    .text_hidden {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    /*修改弹出框*/
    .el-dialog {
        .save-input {
            width: 160px;
            height: 28px;
            line-height: 28px;
            border-radius: 2px;
            border: 1px solid gainsboro;
            padding-left: 5px;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 160px;
            margin-top: 10px;
        }
        .line {
            margin-top: 10px;
            .add {
                width: 20px;
                vertical-align: middle;
                text-align: center;
                font-weight: bolder;
                display: inline-block;
                background: #79C4C7;
                border-radius: 50%;
                color: white;
                font-size: 15px;
                cursor: pointer;
            }
        }
    }

    /*确认删除*/
    .header .el-button--default {
        color: white;
    }

    #app {
        padding: 10px;
        position: relative;
    }

    .right-pop {
        width: 800px;
        display: inline-block;
        position: absolute;
        background: white;
        border: 1px solid gainsboro;
        top: 0;
        right: 0;
        z-index: 99;
        overflow: hidden;
        overflow-y: scroll;
        .head {
            padding: 10px;
            .head-img {
                width: 35px;
                float: left;
            }
            .name {
                margin-top: 9px;
                margin-left: 8px;
                display: inline-block;
            }
            .right {
                float: right;
                margin-top: 5px;
                .move {
                    display: inline-block;
                    float: left;
                    width: 85px;
                    text-align: center;
                    padding: 5px 0;
                    border: 1px solid #adadad;
                    border-radius: 2px;
                    margin-right: 2px;
                    cursor: pointer;
                }
                .el-button--text {
                    float: left;
                    width: 85px;
                    text-align: center;
                    padding: 7px 0;
                    border: 1px solid #adadad;
                    border-radius: 2px;
                    color: black;
                }
                .close {
                    margin-top: 5px;
                    margin-left: 7px;
                    margin-right: 5px;
                    width: 20px;
                }
            }
            .head_content {
                margin-bottom: 7px;
                clear: both;
                span {
                    display: inline-block;
                    margin-left: 30px;
                    padding-top: 12px;
                }
            }
        }
        .el-tabs--border-card {
            box-shadow: none;
        }
        textarea {
            width: 100%;
            height: 63px;
        }
        .fade-enter-active, .fade-leave-active {
            transition: opacity 1s;
        }
        .fade-enter, .fade-leave-to {
            opacity: 0;
        }
        .el-tabs--border-card {
            border-left: 0;
            border-bottom: 0;
        }
        .down_form {
            margin-top: 15px;
            padding-bottom: 20px;
            max-height: 500px;
            overflow: hidden;
            overflow-y: scroll;
            .el-date-editor.el-input, .el-date-editor.el-input__inner {
                width: 135px;
                margin-left: 5px;
                float: left;
            }
            .issue {
                padding: 3px 11px;
                color: #fff;
                background-color: #E6BE8A;
                border: 1px solid #E6BE8A;
                border-radius: 2px;
            }
            .record-content {
                margin-bottom: 10px;
                .record {
                    height: 40px;
                    line-height: 40px;
                    margin-bottom: 10px;
                    margin-top: 20px;
                    padding-left: 20px;
                    background-color: rgb(241, 241, 241);
                    color: rgb(102, 102, 102);
                    span {
                        display: inline-block;
                        padding-right: 50px;
                    }
                    .yet {
                        width: 55px;
                        line-height: 30px;
                        background-color: #449d44;
                        border: 0;
                        border-radius: 5px;
                        color: white;
                        margin-left: 10px;
                        font-size: 14px;
                        cursor: pointer;
                        outline: none;
                    }
                    .not {
                        width: 55px;
                        line-height: 30px;
                        background-color: #f0ad4e;
                        border: 0;
                        border-radius: 5px;
                        color: white;
                        margin-left: 10px;
                        font-size: 14px;
                        cursor: pointer;
                        outline: none;
                    }
                }
                .header-img {
                    float: left;
                    margin: 0 15px;
                    width: 50px;
                }
                .img-txt {
                    display: inline-block;
                    padding: 2px 5px;
                    border-radius: 10px;
                    color: #fff;
                    background-color: #E6BE8A;
                    border-color: #2e6da4;
                    font-size: 14px;
                    font-weight: bold;
                    margin-top: 18px;
                }
                .right-txt {
                    float: right;
                    padding-top: 18px;
                    padding-right: 30px;
                    color: rgb(93, 156, 236);
                    display: inline-block;
                }
                .content {
                    padding-left: 84px;
                    height: 50px;
                    clear: both;
                }
            }

        }

    }

    .header {
        margin-bottom: 15px;
        margin-left: 5px;

        .name {
            display: inline-block;
            height: 36px;
            padding-left: 16px;
            margin-left: 5px;
            font-size: 14px;
            line-height: 1.42857143;
            color: #555;
            background-color: #fff;
            border: 1px solid #ccc;
            border-radius: 4px;
        }
        .el-button {
            padding: 6px 14px;
            background-color: #E6BE8A;
            margin-left: 15px;
            margin-right: 6px;
            vertical-align: middle;
        }
        .refresh-btn {
            width: 43px;
            border: 1px solid #E4E7ED;
            line-height: 24px;
            background-color: white;
            border-radius: 2px;
            cursor: pointer;
            vertical-align: middle;
        }
        .delete {
            width: 110px;
            color: #fff;
            border: 0;
            background-color: #E6BE8A;
            display: inline-block;
            padding: 8px 12px;
            margin-bottom: 0;
            font-size: 14px;
            font-weight: 400;
            line-height: 1.42857143;
            text-align: center;
            border-radius: 3px;
            cursor: pointer;
            margin-left: 5px;
        }
    }

    .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/genjin/caidan.vue